module.exports = __webpack_public_path__ + "img/mongodb.21699527.png";